export const officialJudgingSessionType = '362bcfc5-894d-4bfc-a31f-136857fcfe8e';

export const followUpJudgingSessionType = '30d8c6b4-e27f-4ec5-8feb-e1b8a32ed70c';

export const judgingMaterialsSubmissionDueType = '60d3520a-fe88-42f9-b118-ed0fc85567b5'
export const sessionTranslationsMap = {
  [judgingMaterialsSubmissionDueType]: 'judgingMaterialsSubmissionDueLabel'
}

export const judgingMaterialsSubmissionDueIds = ['60d3520a-fe88-42f9-b118-ed0fc85567b5'];